import * as actionTypes from './constants'

export const cancelImport = (importId, retries = 1) => ({
  type: actionTypes.CANCEL_IMPORT,
  importId,
  retries,
})
export const cancelImportDone = (importId) => ({
  type: actionTypes.CANCEL_IMPORT_DONE,
  importId,
})
export const cancelImportError = (importId, error) => ({
  type: actionTypes.CANCEL_IMPORT_ERROR,
  importId,
  error,
})
export const cancelAllImports = (retries = 1) => ({
  type: actionTypes.CANCEL_ALL_IMPORTS,
  retries,
})
export const cancelAllImportsDone = () => ({
  type: actionTypes.CANCEL_ALL_IMPORTS_DONE,
})
export const cancelAllImportsError = (error) => ({
  type: actionTypes.CANCEL_ALL_IMPORTS_ERROR,
  error,
})
export const getUploadStatus = (projectId, retries = 1) => ({
  type: actionTypes.GET_UPLOAD_STATUS,
  projectId,
  retries,
})
export const getUploadStatusDone = (uploadStatus, clearPrevious) => ({
  type: actionTypes.GET_UPLOAD_STATUS_DONE,
  uploadStatus,
  clearPrevious,
})
export const getUploadStatusError = (error) => ({
  type: actionTypes.GET_UPLOAD_STATUS_ERROR,
  error,
})
export const hideImport = (importId) => ({
  type: actionTypes.HIDE_IMPORT,
  importId,
})
export const hideAllFinishedImports = () => ({
  type: actionTypes.HIDE_ALL_FINISHED_IMPORTS,
})
export const hideAllFinishedExports = () => ({
  type: actionTypes.HIDE_ALL_FINISHED_EXPORTS,
})
export const cancelAllExports = () => ({
  type: actionTypes.CANCEL_ALL_EXPORTS,
})

export const setImportsAsLoaded = () => ({
  type: actionTypes.SET_IMPORTS_AS_LOADED,
})

export const setDownloadStatus = (downloadId, data) => ({
  type: actionTypes.SET_DOWNLOAD_STATUS,
  downloadId,
  data,
})
export const removeDownloadStatus = (downloadId) => ({
  type: actionTypes.REMOVE_DOWNLOAD_STATUS,
  downloadId,
})
